<template>
  <div class="hzc-industry-dynamics">
    <div>当前位置：<span @click="back" style="cursor: pointer">氢能</span> > 加氢站</div>
    <div class="content">
      <div class="header">
        <em></em>
        <p>加氢站</p>
        <div class="btn fr" @click="search">搜索</div>
        <input class="fr" v-model="keyword" type="text" placeholder="请输入关键词">
      </div>
      <div class="tabs">
        <div @click="changeTabs('105')" :class="{'hover':queryParams.sourceType === '105'}">项目动态</div>
        <div @click="changeTabs('106')" :class="{'hover':queryParams.sourceType === '106'}">零售价格</div>
        <div @click="changeTabs('107')" :class="{'hover':queryParams.sourceType === '107'}">运营</div>
        <div @click="changeTabs('6')" :class="{'hover':queryParams.sourceType === '6'}">项目一览表</div>
      </div>
      <ul>
        <li v-for="(item,index) in list" :key="index">
          <img src="../../../assets/home/liebiaoqian.png" alt="">
          <div v-if="queryParams.sourceType !== '6'" style="display: inline-block">
            <p v-if="item.newsType === 1" @click="goDetail(item.id)">{{ item.titleName }}</p>
            <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
          </div>
          <div v-else  style="display: inline-block">
            <p @click="downloadReport(item)">{{ item.fileTitle }}</p>
          </div>
          <span class="fr">{{ item.showYearTime }}</span>
          <em v-if="(index+1)%5 === 0 && (index+1) !== list.length" class="xiaxuxian"></em>
        </li>
      </ul>
    </div>
    <div style="text-align: center;">
      <span
          style="vertical-align:middle;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;"
          @click="goFirst">首页</span>
      <el-pagination
          style="margin: 24px 0;display: inline-block;vertical-align:middle;"
          background
          prev-text="上一页"
          next-text="下一页"
          :page-size="queryParams.pageSize"
          :current-page="queryParams.pageNum"
          @current-change="changePage"
          layout="prev, pager, next,slot, total,jumper"
          :total="total">
        <span
            style="margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;"
            @click="goLast">末页</span>
      </el-pagination>
      <span
          style="margin-left:20px;color:#FFF;background-color:#D3131A;margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;font-weight: normal;cursor: pointer;">跳转</span>
    </div>
  </div>
</template>

<script>
import {
  projectStationDetail,
  projectStationList,
  stationList
} from '@/api/hydrogen'

export default {
  data() {
    return {
      list: [],
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 15,
        sourceType: '105',
        likeTitleName: ''
      },
      query:{
        pageNum: 1,
        pageSize: 15,
        sourceType: 11,
        fileType: '6',
        likeFileTitle:'',
      },
      keyword:''
    }
  },
  created() {
    if (this.$route.query && this.$route.query.flag) {
      this.queryParams['sourceType'] = this.$route.query.flag
      this.queryParams['fileType'] = this.$route.query.flag
    }
    this.getList();
  },
  methods: {
    // 获取列表
    getList() {
      if (this.queryParams.sourceType === '105'||this.queryParams.sourceType === '106'||this.queryParams.sourceType === '107') {
        this.queryParams['likeTitleName'] = this.keyword
        stationList(this.queryParams).then(res => {
          this.list = res.rows;
          this.total = res.total;
        })
      } else {
        this.query['likeFileTitle'] = this.keyword
        projectStationList(this.query).then(res => {
          this.list = res.rows;
          this.total = res.total;
        })
      }
    },
    /**
     * 搜索
     */
    search() {
      this.queryParams['pageNum'] = 1;
      this.query['pageNum'] = 1;
      this.getList()
    },
    /**
     * 前往详情页
     */
    goDetail(id) {
      this.$router.push({path: `/hydrogen/station`, query: {id: id, flag: this.queryParams['sourceType']}})
    },
    /**
     * 下载文件
     */
    downloadReport(row) {
      projectStationDetail(row['id'] + "/1").then((res) => {
        this.$setMenuInfoPath(['氢能', '加氢站', '项目一览表'], row['id']);
      })
    },
    /**
     * 切换tabs
     */
    changeTabs(num) {
      this.queryParams['sourceType'] = num;
      this.queryParams['pageNum'] = 1;
      // this.queryParams['likeTitleName'] = ''
      this.query['fileType'] = num;
      this.query['pageNum'] = 1;
      // this.query['likeFileTitle'] = '';
      this.getList();
    },
    /**
     *  行业动态外链
     */
    openUrl(item) {
      window.openUrl(item.newsContent)
    },
    /**
     * 回退
     */
    back() {
      this.$router.push('/hydrogen')
    },
    /**
     * 分页
     */
    goFirst() {
      this.queryParams['pageNum'] = 1;
      this.query['pageNum'] = 1;
      this.getList()
    },
    goLast() {
      this.queryParams['pageNum'] = Math.ceil(this.total / 15);
      this.query['pageNum'] = Math.ceil(this.total / 15);
      this.getList()
    },
    changePage(page) {
      this.queryParams['pageNum'] = page;
      this.query['pageNum'] = page;
      this.getList()
    },
  }
}
</script>

<style scoped lang="less">
@import "../../../style/twoPage";
</style>
